import React from 'react';
import Title from '../Title';
import ValuesCards from './ValuesCards';
import { useTranslation } from 'react-i18next';

const ValuesSection = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className='flex flex-col p-6 md:p-12 gap-6 md:gap-12'>
        <Title>{t('values.values_title')}</Title>
        <ValuesCards />
      </div>
    </section>
  );
};

export default ValuesSection;